import React from 'react';
import { LogoArea } from 'src/LogoArea/LogoArea';
import { MenuArea } from 'src/MenuArea/MenuArea';
import styles from './Header.module.scss';

interface HeaderProps {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const Header: React.FC<HeaderProps> = ({ onClick }) => {
  return (
    <header className={styles.header}>
      <div className={styles.box}>
        <LogoArea></LogoArea>
        <MenuArea onClick={onClick}></MenuArea>
      </div>
    </header>
  );
};
